import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import { Card, Header, BoldTitle, HorizontalDivider } from '../common/Card';
import LeaseDocumentTypesGroup from './LeaseDocumentTypesGroup';

const LeaseDocumentTypes = ({ values, errors, touched, setFieldValue, leaseDocumentTypes }) => {
  if (leaseDocumentTypes?.length === 0) return null;

  return (
    <Card>
      <Header>
        <BoldTitle>
          {getTranslatedString('landlordPortal.rentRoll.renewals.leaseDocumentTypes.title')}
        </BoldTitle>
      </Header>
      <HorizontalDivider />
      {leaseDocumentTypes.map((document, i) => {
        return (
          <LeaseDocumentTypesGroup data={document} setValues={setFieldValue} values={values} />
        );
      })}
    </Card>
  );
};

export default LeaseDocumentTypes;
